import { render, staticRenderFns } from "./ScriptEmbedGroupEditor.vue?vue&type=template&id=5963f0fa&"
import script from "./ScriptEmbedGroupEditor.vue?vue&type=script&lang=js&"
export * from "./ScriptEmbedGroupEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports